<template>
  <b-alert
      class="message-banner"
      :show="thisShowBanner"
      :variant="variant"
      dismissible
      @dismissed="thisShowBanner=false"
  >
      <span class="span-login-page">
        {{ message }}
      </span>
  </b-alert>
</template>

<script>
export default {
  name: "messageBanner",
  props: ['variant', 'message', 'showBanner', ],
  data(){
    return{
      thisShowBanner: false
    }
  },
  mounted() {
    this.thisShowBanner =  this.showBanner
  }
}
</script>

<style scoped>
.message-banner button{
  background-color: inherit;
  border-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 55px;
  font-size: 1.5rem;
}
</style>